// extracted by mini-css-extract-plugin
export default {"external":"a92YGv","deprecatedBorderRadius":"b92YGv","hasAnimation":"c92YGv","container":"d92YGv"};